// DO NOT USE THIS FILE!
// This is file is deprecated, do not import from it.
// It's used for backward compatability in wix-style-react 1.*

export {
  createDriverFactory,
  DriverFactory,
  BaseDriver,
  ComponentFactory,
} from './driver-factory';
export { isClassExists, makeControlled, sleep } from './react-helpers';

export { testkitFactoryCreator, isTestkitExists } from './vanilla';
export {
  enzymeTestkitFactoryCreator,
  isEnzymeTestkitExists,
  WrapperData,
} from './enzyme';
export { puppeteerTestkitFactoryCreator } from './puppeteer';
